import { useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import ImageCard from '../../components/ImageCard/ImageCard'; // Ваш компонент из предыдущего вопроса
import './Cabinetpage.css'
import library1 from '../../images/Cab_photos/library/3.jpg'
import library2 from '../../images/Cab_photos/library/4.jpg'
import library3 from '../../images/Cab_photos/library/5.jpg'

const CabinetPage3 = () => {
  const { id } = useParams();
  const [activeTab, setActiveTab] = useState('description');
  
  const cabinetData = {
    id: 1,
    title: 'Библиотека',
    images: [
      library1,
      library2,
      library3
    ],
    description: <span><b>Библиотека — современное многофункциональное пространство для знаний и творчества</b><br/> Наша школьная библиотека — это не просто место с книгами, а настоящий образовательный центр, продуманный до мелочей. Пространство разделено на несколько тематических зон, каждая из которых создана для комфортной работы, учебы и отдыха. <br/><br/><b>Дом для любимых книг</b><br/>Здесь царит особая атмосфера литературного уюта. Ученики могут взять на дом художественную литературу — от классических произведений до новинок современной прозы. Опытный библиотекарь всегда поможет подобрать книгу по интересам и возрасту, расскажет о новинках и литературных конкурсах. <br/><br/><b>Зона свободного доступа — царство самостоятельного выбора</b><br/> Открытые стеллажи с книгами, удобная система поиска и уютные уголки для чтения — здесь каждый ученик может свободно перемещаться между полками, листать понравившиеся издания и находить для себя что-то новое. Особой популярностью пользуются тематические выставки, которые регулярно обновляются.</span>,

  };

  return (
    <div className="cabinet-page">
      
      <h1 className="cabinet-title">{cabinetData.title}</h1>
      
        <ImageCard 
          images={cabinetData.images} 
          description={'"Сердце и душа школьной библиотеки - это ее читатели"'}
        />
        <hr className='razdel'/>
      
      <div className="cabinet-content">
        {activeTab === 'description' && (
          <div className="description-section">
            <p>{cabinetData.description}</p>
          </div>
        )}
      </div>
      <div className="next-floor-button-container">
            <Link to="/" className="next-floor-button">
              На главную
            </Link>
    </div>
    </div>
  );
};

export default CabinetPage3;